import HIKOffLineModal from './HIK_off_line-modal.vue'
export default HIKOffLineModal
